export const HOMEOWNER_PROOF_TEXTS: TStringObject = {
  passport: 'Предоставил паспорт',
  rosreestr: 'Проверено Росреестром',
  selfEmployed: 'Сдаёт как самозанятый',
};
